import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Finances from './pages/Finances'
import Nutrition from './pages/Nutrition'
import Plans from './pages/Plans'
import Assistant from './pages/Assistant'
import Settings from './pages/Settings'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="finances" element={<Finances />} />
          <Route path="nutrition" element={<Nutrition />} />
          <Route path="plans" element={<Plans />} />
          <Route path="assistant" element={<Assistant />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
